import { detectFormat } from './detect.js';
import { mhtmlToHtml, UnwrapError } from './mhtml.js';
import { webarchiveToHtml } from './webarchive.js';
export { UnwrapError } from './mhtml.js';
export { detectFormat } from './detect.js';

export function unwrapToHtml(bytes: Uint8Array, fileName: string): string {
  const fmt = detectFormat(bytes, fileName);
  switch (fmt) {
    case 'html': return new TextDecoder('utf-8').decode(bytes);
    case 'mhtml': return mhtmlToHtml(bytes);
    case 'webarchive': return webarchiveToHtml(bytes);
    case 'pdf': throw new UnwrapError('UNSUPPORTED', 'PDF dosyaları henüz desteklenmiyor. Sayfayı Web Arşivi veya HTML olarak kaydedin.');
    case 'image': throw new UnwrapError('UNSUPPORTED', 'Ekran görüntüsü veya fotoğraf okunamaz.');
    default: throw new UnwrapError('UNSUPPORTED', 'Bu dosya bir Alt-Üst Soy belgesi olarak okunamadı.');
  }
}
